const styles = theme => ({
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& p': {
      fontSize: '20px',
      fontWeight: 600,
      color: theme.palette.primary.adgmBlack,
    },
    '& img': {
      cursor: 'pointer',
    },
  },
  content: {
    margin: '20px 0px',
    '& p': {
      fontSize: '18px',
      color: theme.palette.primary.adgmBlack,
      lineHeight: '26px',
    },
  },
  adgmGold: {
    color: theme.palette.primary.main,
  },
  buttonContainer: {
    width: '100%',
    '& button': {
      width: '100%',
      fontSize: '16px',
      background: theme.palette.primary.main,
      color: '#FFF',
      textTransform: 'none',
      height: '48px',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
        background: theme.palette.primary.darkGrey,
      },
    },
  },
  '@media (max-width: 767px)': {
    titleContainer: {
      '& p': {
        fontSize: '16px',
      },
    },
    content: {
      '& p': {
        fontSize: '12px',
        lineHeight: '18px',
      },
    },
    buttonContainer: {
      '& button': {
        height: '40px',
        fontSize: '14px',
      },
    },
  },
});

export default styles;
